import { render, staticRenderFns } from "./ny_jigou.vue?vue&type=template&id=23e756ba&scoped=true&"
import script from "./ny_jigou.vue?vue&type=script&lang=js&"
export * from "./ny_jigou.vue?vue&type=script&lang=js&"
import style0 from "./ny_jigou.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ny_jigou.vue?vue&type=style&index=1&id=23e756ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e756ba",
  null
  
)

export default component.exports